<template>
      <div class="shift">
    <span class="art">
      <i class="fas fa-question"></i>
    </span>
    <div class="p-2 bd-highlight ml-4 try">
      Don't try to be original just try to be good.
      <br />A wonderful serenity has taken possessionof the my
      <br />entire soul, like these sweet mornings of spring
      <br />which I enjoy with my whole heart. I am alone, and
      <br />feel the.
    </div>
    <div class="p-2 bd-highlight pauli ml-5">Pauli Jarvis</div>
      </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page5/pauli.vue